import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(1, 0),
  },
  total: {
    fontWeight: '700',
  },
  title: {
    color: "#3C4858",
    margin: "1.75rem 0 0.875rem !important",
    marginTop: "30px",
    minHeight: "unset",
    // font-family: "Roboto Slab", "Times New Roman", serif;
    fontWeight: 700,
    marginBottom: "25px",
    textDecoration: "none",
    fontSize: '18px'
  },
  description: {
    // color: grayColor,
    overflow: "hidden",
    marginTop: "0px",
    fontSize: "16px"
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  checboxes: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  button: {
    // marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const mapStateToProps = (state) => ({
  catalog: state.catalogs,
  socialCommunity: state.socialCommunity

})

export default connect(mapStateToProps) (function Review({socialCommunity, handleSubmit, handleBack}) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    checked: false,
  });

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };

  React.useEffect(() => {
//     /*
// Ідентифікатор батківського елементу для відображення iframe, 
// який завантажує сторінку SignWidget
// */
// const SIGN_WIDGET_PARENT_ID		= "sign-widget-parent";
// /*
// Ідентифікатор iframe, який завантажує сторінку SignWidget
// */
// const SIGN_WIDGET_ID			= "sign-widget";
// /*
// URI з адресою за якою розташована сторінка SignWidget
// */
// // const SIGN_WIDGET_URI			= "https://eu.iit.com.ua/sign-widget/v20190408/";
// const SIGN_WIDGET_URI			= "https://id.gov.ua/sign-widget/v20190515/";

// //=============================================================================

// /*
// Створення об'єкту типу EndUser для взаємодії з iframe, 
// який завантажує сторінку SignWidget
// */
// const euSign = new EndUser(
// SIGN_WIDGET_PARENT_ID, 
// SIGN_WIDGET_ID, 
// SIGN_WIDGET_URI,
// EndUser.FormType.ReadPKey
// );

// setEusign(euSign)

}, [])
// console.log(eusign._recieveMessage);
  return (
    <React.Fragment>
      <Typography variant="h4" gutterBottom>
        Перегляд заяви
      </Typography>
      {/* <List disablePadding>
        {socialCommunity.requestDetails.map(product => (
          <ListItem className={classes.listItem} key={product.merchantName}>
            <ListItemText primary={product.merchantName} secondary={product.desc} />
            <ListItemText primary={product.agentSurname} secondary={product.desc} />
            <ListItemText primary={product.agentName} secondary={product.desc} />
            <ListItemText primary={product.agentPatronymic} secondary={product.desc} />
            <ListItemText primary={product.phone} secondary={product.desc} />
            <ListItemText primary={product.email} secondary={product.desc} />
            <Typography variant="body2">{product.price}</Typography>
          </ListItem>
        ))} */}
       
      {/* </List> */}
      <Grid container spacing={2}>

      <Grid item xs={12} sm={4}>

      <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          ПІБ
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.commonName}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          ЄДРПОУ із КЕП
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.iCodeSigner}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Найменування організації
          </Typography>
<Typography gutterBottom className={classes.description}>{socialCommunity.organization}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Область
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.state}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Населений пункт
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.locality}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
            Найменування громади
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.communityName}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Юридична адреса
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.address}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Юридична адреса
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.communityName}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Офіційний телефон
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.communityPhone}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Адреса офіційної електронної пошти

          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.communityEmail}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Офіційний сайт організації *
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.url}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          ЄДРПОУ ради, навколо, якої об'єдналася громада
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.iCodeRada}</Typography>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Кількість модулів шифрування 
          </Typography>
      <Typography gutterBottom className={classes.description}>{socialCommunity.count}</Typography>
        </Grid>
</Grid>

        <Grid item xs={12} sm={8}>
        <Grid item xs={12} sm={12}>
          <Typography variant="span" gutterBottom className={classes.title}>
          Суб'єкти, у яких буде застосовано МШ та контакти
          </Typography>
          <Grid item xs={12} sm={12} >
            {/* {socialCommunity.requestDetails.map(payment => (
              <React.Fragment key={payment.name}>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.merchantName}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.agentSurname}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.agentName}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.agentPatronymic}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.phone}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom className={classes.description}>{payment.email}</Typography>
                </Grid>
              </React.Fragment>
            ))} */}

             {/* <List disablePadding>
        {socialCommunity.requestDetails.map(product => (
          <ListItem className={classes.listItem} key={product.merchantName}>
            <ListItemText primary={product.merchantName} secondary={product.desc} />
            <ListItemText primary={product.agentSurname} secondary={product.desc} />
            <ListItemText primary={product.agentName} secondary={product.desc} />
            <ListItemText primary={product.agentPatronymic} secondary={product.desc} />
            <ListItemText primary={product.phone} secondary={product.desc} />
            <ListItemText primary={product.email} secondary={product.desc} />
            <Typography variant="body2">{product.price}</Typography>
          </ListItem>
        ))}
       
      </List> */}
      <div className="table-responsive">
      <Table className={classes.table} aria-label="simple dense table">
        <TableHead>
          <TableRow>
            <TableCell>Найменування суб'єкту, у якому буде застосовано МШ</TableCell>
            <TableCell>Прізвище  уповноваженої особи</TableCell>
            <TableCell>Ім'я  уповноваженої особи </TableCell>
            <TableCell>По батькові  уповноваженої особи </TableCell>
            <TableCell>Контактний телефон </TableCell>
            <TableCell>Адреса електронної пошти  </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {socialCommunity.requestDetails.map((row, index) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.merchantName}
              </TableCell>
              <TableCell align="right">{row.agentSurname}</TableCell>
              <TableCell align="right">{row.agentName}</TableCell>
              <TableCell align="right">{row.agentPatronymic}</TableCell>
              <TableCell align="right">{row.phone}</TableCell>
              <TableCell align="right">{row.email}</TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </div>
      </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
        <div className={classes.checboxes}>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox checked={state.checked} color="primary" onChange={handleChange('checked')} value="checked" />
            }
            label="Бажаю підключити громаду до програмного комплексу “Інтегрована інформаційна система ”Соціальна громада”"
          />
        </FormGroup>
                  </div>
        </Grid>
        <Grid item xs={12}>
        <div className={classes.buttons}>
        <Button variant="contained" color="primary" onClick={handleBack}>Назад</Button>
        <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.button}
                    disabled={!state.checked}
                  >
                    Подати
                  </Button>
                  </div>
                  </Grid>
      </Grid>
    </React.Fragment>
  );
})